import { forwardRef } from "react";
import { LucideProps } from "lucide-react";

/**
 * SUP board (no sail) drawn in lucide's outline style.
 * lucide-react has no paddleboard/surfboard icon, so this custom icon keeps the
 * SUP service card visually consistent with the other lucide service icons.
 */
const SupBoardIcon = forwardRef<SVGSVGElement, LucideProps>(
    (
        { size = 24, color = "currentColor", strokeWidth = 2, absoluteStrokeWidth, className, ...rest },
        ref,
    ) => (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={
                absoluteStrokeWidth
                    ? (Number(strokeWidth) * 24) / Number(size)
                    : strokeWidth
            }
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...rest}
        >
            {/* board */}
            <path d="M9 3c2.4 3.4 2.4 14.2 0 18-2.4-3.8-2.4-14.6 0-18Z" />
            {/* stringer */}
            <path d="M9 7v10" />
            {/* paddle shaft */}
            <path d="M16.5 21 17.2 7" />
            {/* paddle blade */}
            <path d="M15 3.2h4l-.6 3.8h-2.8z" />
        </svg>
    ),
);

SupBoardIcon.displayName = "SupBoardIcon";

export default SupBoardIcon;
